// extracted by mini-css-extract-plugin
module.exports = {"mobile":"LeaveMsg_mobile__gOErl"};
module.exports.__checksum = "ef59d8657b97"
